// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetQuotesApiParameter } from "@insite/client-framework/Services/QuoteService";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";

export interface GetCustomQuotesApiParameter extends GetQuotesApiParameter {
    DateRangeStart?: string;
    DateRangeEnd?: string;
    productNumber?: string;
    poNumber?: string;
    orderTotalOperator?: string;
    orderTotal?: string;
    status?: string;
}

type HandlerType = Handler<GetCustomQuotesApiParameter & UpdateSearchFieldsType>;

export const DispatchUpdateSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Pages/RfqMyCustomQuotes/UpdateSearchFields",
        parameter: props.parameter,
    } as any);
};

export const chain = [DispatchUpdateSearchFields];

const updateSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateSearchFields");
export default updateSearchFields;
